export default __webpack_public_path__ + "static/media/volley-appsumo.7274988a.svg";